"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Checkbox = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _freeRegularSvgIcons = require("@fortawesome/free-regular-svg-icons");
var _Checkbox = require("./Checkbox.styled");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Checkbox = exports.Checkbox = function Checkbox(_ref) {
  var id = _ref.id,
    className = _ref.className,
    dataTestId = _ref.dataTestId,
    checked = _ref.checked,
    onClick = _ref.onClick,
    isV2 = _ref.isV2,
    ddActionName = _ref.ddActionName;
  var _useState = (0, _react.useState)(checked),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isChecked = _useState2[0],
    setChecked = _useState2[1];
  var handleClick = function handleClick(checkedStatus) {
    setChecked(checkedStatus);
    onClick && onClick(checkedStatus);
  };
  var testId = isV2 ? "".concat(dataTestId, "-").concat(id) : dataTestId;
  var additionalProps = isV2 ? {} : {
    size: 'lg'
  };
  var color = isV2 ? '#fff' : '#5C617C';
  return /*#__PURE__*/_react["default"].createElement(_Checkbox.StyledCheckbox, {
    id: id,
    className: className,
    checked: isChecked,
    onClick: function onClick() {
      return handleClick(!isChecked);
    },
    "data-testid": testId,
    "data-dd-action-name": ddActionName
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, (0, _extends2["default"])({
    icon: isChecked ? _freeSolidSvgIcons.faCheckSquare : _freeRegularSvgIcons.faSquare,
    color: color
  }, additionalProps)), /*#__PURE__*/_react["default"].createElement("span", {
    className: "visually-hidden",
    "data-testid": "selected-presenter-source"
  }, isChecked ? 'Checked' : 'Unchecked'));
};
Checkbox.propTypes = {
  id: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  className: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  checked: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  isV2: _propTypes["default"].bool,
  ddActionName: _propTypes["default"].string
};
Checkbox.defaultProps = {
  checked: false,
  ddActionName: ''
};
var _default = exports["default"] = Checkbox;